import {
  Directive,
  ElementRef,
  HostListener,
  NgModule,
  Optional,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberInput]',
})
export class NumberInputDirective {
  constructor(
    private ele: ElementRef,
    @Optional() private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInputChange(event): void {
    const inputElement = this.ele.nativeElement as HTMLInputElement;
    const originalValue = inputElement.value;

    const errors: any = {};

    if (originalValue.startsWith(' ')) {
      inputElement.value = '';
      errors.invalidStart = true;
      errors.required = true;
    } else {
      const cleanedValue = originalValue.replace(/[^0-9]/g, '');

      if (cleanedValue !== originalValue) {
        inputElement.value = cleanedValue;
        errors.invalidCharacters = true;
      }

      // Check for empty value
      if (!cleanedValue) {
        errors.required = true;
      }
    }

    // Set or clear form control errors
    if (this.control?.control) {
      const hasErrors = Object.keys(errors).length > 0;
      this.control.control.setErrors(hasErrors ? errors : null);
    }
  }
}

@Directive({
  selector: '[appNumberSpecialInput]',
})
export class NumberSpecialInputDirective {
  constructor(
    private ele: ElementRef,
    @Optional() private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInputChange(event): void {
    const inputElement = this.ele.nativeElement as HTMLInputElement;
    const originalValue = inputElement.value;

    const errors: any = {};

    if (inputElement.name !== 'exchange_rate') {
      if (originalValue.startsWith(' ')) {
        inputElement.value = '';
        errors.invalidStart = true;
        errors.required = true;
      } else {
        const cleanedValue = originalValue.replace(/[^0-9,]/g, '');

        if (cleanedValue !== originalValue) {
          inputElement.value = cleanedValue;
          errors.invalidCharacters = true;
        }

        // Check for empty value
        if (!cleanedValue) {
          errors.required = true;
        }
      }
    } else {
      inputElement.value = originalValue.replace(/[^0-9.]/g, '');
    }

    // Set or clear form control errors
    if (this.control?.control) {
      const hasErrors = Object.keys(errors).length > 0;
      this.control.control.setErrors(hasErrors ? errors : null);
    }
  }
}

@Directive({
  selector: '[appNumericSpecialInput]',
})
export class AlphaNumericInputDirective {
  constructor(
    private ele: ElementRef,
    @Optional() private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInputChange(event: InputEvent): void {
    const inputElement = this.ele.nativeElement as HTMLInputElement;
    const originalValue = inputElement.value;

    // Block if starts with / or -
    if (
      originalValue.startsWith('/') ||
      originalValue.startsWith(',') ||
      originalValue.startsWith('-')
    ) {
      inputElement.value = '';
      if (this.control?.control) {
        this.control.control.setErrors({ invalidStart: true });
      }
      return;
    }

    const cleanedValue = originalValue.replace(/[^0-9-/a-zA-Z,]/g, '');

    if (cleanedValue !== originalValue) {
      inputElement.value = cleanedValue;
      if (this.control?.control) {
        this.control.control.setErrors({ invalidCharacters: true });
      }
    } else {
      // Clear errors if all is good
      if (this.control?.control) {
        this.control.control.setErrors(null);
      }
    }
  }
}

@NgModule({
  declarations: [
    NumberInputDirective,
    NumberSpecialInputDirective,
    AlphaNumericInputDirective,
  ],
  exports: [
    NumberInputDirective,
    NumberSpecialInputDirective,
    AlphaNumericInputDirective,
  ],
})
export class NumberInputDirectiveModule {}
